export type DrawLevel = "full" | "lite" | "off";

/** `true`/`false` still spell the two ends, so old call sites read unchanged. */
function levelOf(value: DrawLevel | boolean): DrawLevel {
  if (value === true) return "full";
  if (value === false) return "off";
  return value;
}

export class DrawGate {
  private level_: DrawLevel;

  constructor(drawing: DrawLevel | boolean = "full") {
    this.level_ = levelOf(drawing);
  }

  /** Which of the three levels this client is on. */
  get level(): DrawLevel {
    return this.level_;
  }

  /** Is the scene being painted this frame? True for `lite` -- it draws. */
  get drawing(): boolean {
    return this.level_ !== "off";
  }

  /** Is the world behind the actors being skipped? */
  get reduced(): boolean {
    return this.level_ === "lite";
  }

  /** Change level at runtime (`window.__metin3.draw(false)`, `draw("lite")`). */
  set(drawing: DrawLevel | boolean): void {
    this.level_ = levelOf(drawing);
  }

  scene(draw: (level: DrawLevel) => void): void {
    if (this.level_ !== "off") draw(this.level_);
  }
}

export function drawGateFrom(params: URLSearchParams): DrawGate {
  const value = params.get("draw");
  if (value === null) return new DrawGate("full");
  const spelling = value.trim();
  if (/^(lite|reduced)$/i.test(spelling)) return new DrawGate("lite");
  return new DrawGate(/^(0|false|off|no)$/i.test(spelling) ? "off" : "full");
}
